<template>
  <div>
    <div
      v-if="label"
      class="section--label"
    >
      {{ label }}
    </div>
    <div class="section">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Section',
  props: {
    label: { type: String, default: '' },
  }
}
</script>

<style scoped>
.section {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
}

.section--label {
  color: var(--Basic-800, rgba(9, 21, 64, 0.68));
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 13px;
  letter-spacing: 0;
  text-transform: uppercase;
  padding: 0 20px;
  margin-bottom: 12px;
}
</style>
